window.addEventListener("load", scrollSnapControls);

function scrollSnapControls() {
    document.querySelectorAll('.scroll-snap').forEach(scrollSnap => {
        const feature = scrollSnap.querySelector('.featured-item');
        const arrows = scrollSnap.querySelector('.arrows');
        const featuredSlider = scrollSnap.querySelector('.posts-slider');
        const navItems = Array.from(scrollSnap.querySelectorAll('.nav-item'));
        if (featuredSlider) {
            const slides = Array.from(featuredSlider.children); // Assuming each child is a slide

            if (arrows) {
                const arrowLeft = arrows.querySelector('.arrow-left');
                const arrowRight = arrows.querySelector('.arrow-right');
                let widthFeatured = feature.offsetWidth;

                arrowLeft.addEventListener("click", () => {
                    const activeIndex = getActiveIndex(navItems);
                    if (activeIndex > 0) {
                        updateSliderAndNav(featuredSlider, navItems, widthFeatured * (activeIndex - 1), activeIndex - 1);
                    }
                });

                arrowRight.addEventListener("click", () => {
                    const activeIndex = getActiveIndex(navItems);
                    if (activeIndex < navItems.length - 1) {
                        updateSliderAndNav(featuredSlider, navItems, widthFeatured * (activeIndex + 1), activeIndex + 1);
                    }
                });
            }

            navItems.forEach((navItem, index) => {
                let widthFeatured = feature.offsetWidth;
                navItem.addEventListener("click", () => {
                    updateSliderAndNav(featuredSlider, navItems, widthFeatured * index, index);
                });
            });

            // Create IntersectionObserver to detect which slide is in view
            const observerOptions = {
                root: featuredSlider,
                rootMargin: '0px',
                threshold: 0.5 // Trigger when 50% of a slide is visible
            };

            const observerCallback = (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const activeIndex = slides.indexOf(entry.target);
                        updatePagination(navItems, activeIndex);
                    }
                });
            };

            const observer = new IntersectionObserver(observerCallback, observerOptions);

            // Observe each slide
            slides.forEach((slide) => {
                observer.observe(slide);
            });
        }
    });
}

function getActiveIndex(navItems) {
    return navItems.findIndex(item => item.classList.contains('active'));
}

function updateSliderAndNav(slider, navItems, scrollPosition, activeIndex) {
    slider.scrollLeft = scrollPosition;
    removeAllActiveClasses(navItems);
    navItems[activeIndex].classList.add('active');
}

function updatePagination(navItems, activeIndex) {
    removeAllActiveClasses(navItems);
    navItems[activeIndex].classList.add('active');
}

function removeAllActiveClasses(items) {
    items.forEach(item => item.classList.remove('active'));
}
